import { createORPCClient } from '@orpc/client';
import { RPCLink } from '@orpc/client/fetch';
import type { RouterClient } from '@orpc/server';
import type { AppRouter } from '@server/rpc';

/** Extract workspace slug from current URL path (/w/:slug/...). */
function getWorkspaceSlug(): string | null {
  const re = /^\/w\/([^/]+)/;
  const match = re.exec(window.location.pathname);
  return match?.[1] ?? null;
}

const link = new RPCLink({
  // Dynamic URL: /rpc/w/:slug/... when inside a workspace, /rpc/... otherwise
  url: () => {
    const slug = getWorkspaceSlug();
    const prefix = slug ? `/rpc/w/${encodeURIComponent(slug)}` : '/rpc';
    return new URL(prefix, window.location.origin);
  },
  fetch: (input, init) => fetch(input, { ...init, credentials: 'include' }),
});

export const client: RouterClient<AppRouter> = createORPCClient(link);
